export const attendance = {
  updateFail: 'アップデートに失敗しました',
  updateSuccessfully: '更新に成功',
  createFail: '資格情報の生成に失敗しました',
  createSuccessfully: '情報の作成が完了しました。',
  deleteSuccessfully: '出席を削除しました。',
  deleteFail: '出席の削除に失敗しました!',
}
